import { StoryblokComponent } from '@storyblok/react';

import { useGlobalProviderContext } from '../../../context/global';
import { JsonObject } from '../../../types/jsonObject';
import { getServiceOSPasswordResetQueryParams } from '../../../utils/getServiceOSPasswordResetQueryParams';
import { ServiceOSApiClient } from '../../../utils/serviceOSApiClient';
import { FormBuilderRequestLifecycleContext } from '../../FormBuilder/FormBuilder.types';
import { ProChangePasswordFormProps } from './ProChangePasswordForm.types';
import { useRouter } from 'next/router';

const serviceOSApiClient = new ServiceOSApiClient();

export const ProChangePasswordForm = (props: ProChangePasswordFormProps) => {
  const { blok } = props;
  const { form } = blok;

  const router = useRouter();
  const globalContext = useGlobalProviderContext();

  if (!form.length) {
    return null;
  }

  const { values } = getServiceOSPasswordResetQueryParams(globalContext.serviceOSSettings);

  const handleSubmit = async (data: JsonObject, context: FormBuilderRequestLifecycleContext) => {
    if (!values.token) {
      context.setErrorMessage('No password reset token provided');
      return;
    }

    const { successMessage, errorMessage } = await serviceOSApiClient.changePassword(
      values.token,
      data.password as string,
      data.confirm_password as string
    );

    if (errorMessage) {
      context.setErrorMessage(errorMessage);
    } else if (successMessage) {
      context.setSuccessMessage(successMessage);
      if (globalContext.serviceOSSettings.postPasswordResetPageUrl) {
        void router.push(globalContext.serviceOSSettings.postPasswordResetPageUrl);
      }
    }
  };

  const formBuilderBlok = {
    ...form[0],
    submitDataAs: 'json',
  };

  return (
    <StoryblokComponent blok={formBuilderBlok} key={formBuilderBlok._uid} onSubmit={handleSubmit} />
  );
};
